import { render } from "./Coin.vue?vue&type=template&id=05ae5a2e&scoped=true&ts=true"
import script from "./Coin.vue?vue&type=script&lang=ts"
export * from "./Coin.vue?vue&type=script&lang=ts"

import "./Coin.vue?vue&type=style&index=0&id=05ae5a2e&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ae5a2e"]])

export default __exports__